module.exports = __webpack_public_path__ + "static/img/image-booking-bg.311590d7.png";